import {SeniorityDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_SENIORITY';

export async function getAllSeniority(
    userData: UserState["userProfileData"],
    params: string,
    page: number
) {
    try {
        const result = await SeniorityDao.getAllSeniority(userData?.userToken as string , params, page);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
